export enum SyncErrorType {
  None,
  SyncNotPossible,
  PartialSync,
  LockNotPossible,
}
